import { PropsWithChildren, useEffect, useRef } from 'react';

import { Button, ButtonProps, forwardRef } from '@bonusly/design-system';

type UploadButtonProps = PropsWithChildren<
	Omit<ButtonProps, 'onChange'> & {
		accept?: string | string[];
		onChange?: (file: File) => void;
	}
>;

export const UploadButton = forwardRef<UploadButtonProps, 'button'>(({ accept, onChange, ...rest }, ref) => {
	const elRef = useRef<HTMLInputElement>();

	const handleClick = () => {
		const el = document.createElement('input');
		el.setAttribute('type', 'file');
		el.style.display = 'none';

		if (accept) {
			el.setAttribute('accept', typeof accept === 'string' ? accept : accept.join(','));
		}

		document.body.appendChild(el);

		el.addEventListener('change', (e: any) => {
			if (e.target && e.target.files) {
				onChange?.(e.target.files[0]);
			}

			el.remove();
		});

		const removeEl = () => {
			el.remove();
			window.removeEventListener('focus', removeEl);
		};

		window.addEventListener('focus', removeEl);
		elRef.current = el;
		el.click();
	};

	useEffect(() => {
		return () => {
			if (elRef.current) {
				elRef.current.remove();
			}
		};
	}, []);

	return <Button onClick={handleClick} ref={ref} {...rest} />;
});
